import { Component, ElementRef, Renderer2, OnInit,AfterViewInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HowWorkComponent } from '../how-work/how-work.component';
import { SharedService } from '../../../services/shared/shared.service';
import { AboutComponent } from '../../about/about.component';
import { FirestoreService } from '../../../services/firestore/firestore.service';
import { FaqDto } from '../../../models/faq-dto';
import { JobDto } from '../../../models/job-dto';
import { AuthServiceService } from '../../../services/authService/auth-service.service';
import Swal from 'sweetalert2';
import { Article } from '../../../models/article';
import AOS from 'aos';
import 'aos/dist/aos.css';
declare var $: any;

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    RouterLink,
    CommonModule,
    HowWorkComponent,
    AboutComponent
  ],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  faqs: FaqDto[] = [];
  jobs: JobDto[] = [];
  articles: Article[] = [];
  showArticleSpinner=true;
  showJobSpinner=true;

  isLoggedIn=false;
  

damyArray=new Array(6);
  constructor(
    public sharedService: SharedService,
    private renderer: Renderer2,
    private el: ElementRef,
    private firestoreService: FirestoreService,
    private authService:AuthServiceService,
    private router:Router ,

  ) {}

  ngOnInit() {
    this.getAllFaqs();
    this.getAllJob();
    this.isUserLoggedIn();
    this.getAllArticles();

    setTimeout(() => {
      this.activeFaqItem();
    }, 500);
  }
 ngAfterViewInit(): void {
    AOS.init({
      once: true, // animation happens only once
      duration: 800,
      offset: 100,
      easing: 'ease-in-out',
    });


    setTimeout(() => this.initializeSlick(), 500);

  }
  getAllFaqs() {
    this.firestoreService.getAll('faqs').subscribe({
      next: (data) => {
        this.faqs = data;
        // Re-apply FAQ toggle logic after data is loaded
        setTimeout(() => {
          this.activeFaqItem();
        }, 0);
      },
      error: (err) => {
        console.error('Error fetching FAQs:', err);
      }
    });
  }
 
  activeFaqItem() {
    const faqItems = this.el.nativeElement.querySelectorAll('.faq-item');
  
  
    faqItems.forEach((faqItem: HTMLElement) => {
      this.renderer.listen(faqItem, 'click', (event) => {
  
        faqItems.forEach((item: HTMLElement) => {
          this.renderer.removeClass(item, 'faq-active');
        });
  
        this.renderer.addClass(faqItem, 'faq-active');
  
        const content = faqItem.querySelector('.faq-content') as HTMLElement;
        if (content) {
          const isActive = faqItem.classList.contains('faq-active');
          this.renderer.setStyle(content, 'display', isActive ? 'block' : 'none');
        }
      });
    });
  }

   getAllJob() {
    this.firestoreService.getAll('jobs').subscribe({
      next: (data) => {
        this.showJobSpinner=false
        this.jobs = data;
        if (this.jobs.length>6) {
          this.jobs=this.jobs.slice(0,6)
        }
      },
      error:()=>this.showJobSpinner=false
     
    });
  }


  isUserLoggedIn(){
    this.authService.isUserLoggedIn().subscribe({
      next:res=>{ this.isLoggedIn=res},
    })
  }


navigateToApplicationComponent(jobId: string) {
  if (this.isLoggedIn) {
    this.router.navigateByUrl("/application/" + jobId);
  } else {
    Swal.fire({
      icon: 'warning',
      title: 'Nicht angemeldet',
      text: 'Sie müssen sich zuerst anmelden, um sich für diesen Job zu bewerben.',
      confirmButtonText: 'OK'
    });
  }
}



  getAllArticles() {
    this.firestoreService.getAll('articles').subscribe({
      next: (data) => {
    this.articles=[];

        this.articles = data;
        this.showArticleSpinner=false;
        setTimeout(() => this.initializeSlick(), 500); // wait for DOM update
      },
    
      error:()=> this.showArticleSpinner=false
    });
  }

  initializeSlick(): void {
    const $slider = $(this.el.nativeElement).find('.artilce-slider');

    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick'); // destroy old slider if re-initialized
    }

    $slider.slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 992,
          settings: { slidesToShow: 2 }
        },
        {
          breakpoint: 768,
          settings: { slidesToShow: 1 }
        }
      ]
    });
    console.log('Slick initialized successfully');
  }

}